var map = {
	"./black/yinliangjian.png": "7z37",
	"./blue/yinliangjian.png": "S3lx",
	"./white/yinliangjian.png": "6N2q"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9D27";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/yinliangjian\.png$
// module id = 9D27
// module chunks = 24